var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleRedError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x-circle-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_169",
    "data-name": "Tracciato 169",
    d: "M36,18A18,18,0,1,1,18,0,18,18,0,0,1,36,18Zm-9.329-7.079a1.126,1.126,0,1,0-1.593-1.593L18,16.409l-7.079-7.08a1.126,1.126,0,1,0-1.593,1.593L16.409,18,9.328,25.079a1.126,1.126,0,0,0,1.593,1.593L18,19.591l7.079,7.081a1.126,1.126,0,1,0,1.593-1.593L19.591,18l7.081-7.079Z",
    fill: "#c42500",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRedError);
export default __webpack_public_path__ + "static/media/circle-red-error.de2a27122a2d061ec47a0241a7357502.svg";
export { ForwardRef as ReactComponent };